export function ngettext(singular: string, plural: string, num: number) {
    if (num === 1) {
        return singular;
    } else {
        return plural;
    }
}
